import React, { useEffect, useState } from 'react';
import { FaTrash } from 'react-icons/fa';
import { useExtendedMutation } from 'mutations';
import { fetchCards, deleteCard } from 'api';
import { Table } from "components";
import { useAuth } from "react-oidc-context";

const WordListPage = () => {
  const auth = useAuth();
  const token = auth.user?.access_token;
  const [isNarrow, setIsNarrow] = useState(window.innerWidth < 700);
  
  const [rowData, setRowData] = useState([]);
  const [columnDefs, setColumnDefs] = useState([
    { 
      cellClass: 'no-border',
      headerName: 'Word',
      field: 'word',
      flex: 2,
      autoHeight: true,
      visibleWhenNotNarrow: true,
      cellStyle: {textAlign: 'center',  'white-space': 'normal'}
    },
    { 
      cellClass: 'no-border',
      headerName: 'Definition',
      field: 'definition',
      flex: 2,
      autoHeight: true,
      visibleWhenNotNarrow: true,
      cellStyle: {textAlign: 'center',  'white-space': 'normal'}
    },
    {
      cellClass: 'no-border',
      headerName: 'Word',
      flex: 4,
      visibleWhenNarrow: true,
      autoHeight: true,
      cellStyle: {textAlign: 'center',  'white-space': 'normal'},
      cellRenderer: (params) => {
        return (
          <>
            <span className="word-text">{params.data?.word}</span> = 
            <span className="definition-text">{params.data?.definition}</span>
          </>
        );
      }
    },
    {
      cellClass: 'no-border',
      headerName: '',
      flex: 1,
      wrapText: true,
      autoHeight: true,
      cellStyle: {textAlign: 'center',  'white-space': 'normal'},
      cellRenderer: (params) => (
        <FaTrash
          onClick={() => handleDelete(params.node)}
          style={{ cursor: 'pointer', color: '#332d3c' }}
        />
      ),
    }
  ]);

  const getCardsSuccessCallback = (data) => {
    setRowData(data);
  }

  const getCardsErrorCallback = (error) => {
    console.error('Error submitting data:', error);
    setRowData(
      [
        {userId:'Bogdan', score: "4", word: "dummy dummy dummy dummy dummy dummy dummy dummy dummy dummy dummy dummy dummy dummy dummy dummy", definition: "dummyDef"},
        {userId:'Bogdan', score: "5", word: "dummydummy", definition: "dummyDef3"}
      ]);
  }

  const deleteCardSuccessCallback = (data) => {
    getCardsMutation.mutateOnVirtualThread({token: token});
  }

  const deleteCardErrorCallback = (error) => {
    console.error('Error deleting data:', error);
  }

  const getCardsMutation = useExtendedMutation(fetchCards, getCardsSuccessCallback, getCardsErrorCallback);
  const deleteCardMutation = useExtendedMutation(deleteCard, deleteCardSuccessCallback, deleteCardErrorCallback);

  useEffect(() => {
    getCardsMutation.mutateOnVirtualThread({token: token});
    //I have no memory of what the below was supposed to do
    const handleResize = () => setIsNarrow(window.innerWidth < 800);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleDelete = (node) => {
    deleteCardMutation.mutateOnVirtualThread({ word: node.id, token: token });
  };

  const finalColumnDefs = columnDefs.map((col) => {
    let hide = false;

    if (col.visibleWhenNotNarrow && isNarrow) hide = true;
    if (col.visibleWhenNarrow && !isNarrow) hide = true;

    return { ...col, hide };
  });

  return (
    <Table
      columnDefs={finalColumnDefs}
      rowData={rowData}
    />);
};

export { WordListPage }